import { AppContext } from '@app/providers';
import { useWindowSize } from '@utils/hooks';
import { useContext } from 'react';

const HEADER_VISIBILITY_MIN_WIDTH = 480;
const HEADER_VISIBILITY_MIN_HEIGHT = 720;

export const useHeaderVisibility = () => {
  const { width: windowWidth, height: windowHeight } = useWindowSize();
  const { isTelegramBot } = useContext(AppContext);

  return (
    windowWidth > HEADER_VISIBILITY_MIN_WIDTH &&
    windowHeight > HEADER_VISIBILITY_MIN_HEIGHT &&
    !isTelegramBot
  );
};
